// assets/product-customization.js
// 名入れ・番号入れフォームの入力制御
// - 名入れ: 小文字を自動で大文字化し、大文字英数字（A-Z / 0-9）以外を除去。最大10文字
// - 番号入れ: 数字以外を除去。最大2桁（先頭ゼロは保持: 0 / 00 / 07 も有効）
// - 未入力のままカート追加しようとすると日本語のエラーメッセージを表示

/**
 * 入力タイプごとのサニタイズ定義
 */
const SANITIZERS = {
  name: (value) => value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10),
  number: (value) => value.replace(/[^0-9]/g, '').slice(0, 2),
};

class ProductCustomization extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-customization-input]').forEach((input) => {
      input.addEventListener('input', this.#handleInput);
      // invalid イベントはバブリングしないため各inputに直接付与
      input.addEventListener('invalid', this.#handleInvalid);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-customization-input]').forEach((input) => {
      input.removeEventListener('input', this.#handleInput);
      input.removeEventListener('invalid', this.#handleInvalid);
    });
  }

  /**
   * 入力のたびに許可外の文字を除去する（ペースト・IME確定も input イベントで拾える）
   * @param {Event & {target: HTMLInputElement}} event
   */
  #handleInput = (event) => {
    const input = event.target;
    const sanitize = SANITIZERS[input.dataset.customizationInput];
    if (!sanitize) return;

    const sanitized = sanitize(input.value);
    if (sanitized !== input.value) {
      const caret = input.selectionStart;
      input.value = sanitized;
      // 除去された分だけカーソルがずれるので末尾に飛ばないよう補正
      if (caret !== null) {
        const position = Math.min(caret, sanitized.length);
        input.setSelectionRange(position, position);
      }
    }

    // 入力があればカスタムエラーを解除（解除しないと永久にinvalidのまま）
    input.setCustomValidity('');
  };

  /**
   * バリデーションエラー時に日本語メッセージを設定する
   * @param {Event & {target: HTMLInputElement}} event
   */
  #handleInvalid = (event) => {
    const input = event.target;
    if (input.validity.valueMissing) {
      input.setCustomValidity(input.dataset.errorRequired || '');
    } else if (input.validity.patternMismatch || input.validity.tooLong) {
      input.setCustomValidity(input.dataset.errorPattern || '');
    } else {
      input.setCustomValidity('');
    }
  };
}

if (!customElements.get('product-customization-component')) {
  customElements.define('product-customization-component', ProductCustomization);
}
